@if (isSideMenuOpen$ | async) {
  <div
    class="sidebar left extended"
    [class.z-502]="(isSideMenuMinified$ | async) === false"
    [class.shadow-left]="(isSideMenuMinified$ | async) === false"
    @slideInOut_Main
  >
    <soft-side-menu
      class="side-menu"
      (close)="isTabletScreen || isDesktopScreen ? minimizeSideMenu() : closeSideMenu()"
      (execute)="
        isTabletScreen
          ? minimizeSideMenu()
          : !isDesktopScreen
            ? closeSideMenu()
            : undefined
      "
      (open)="maximizeSideMenu()"
      [isMinified]="
        (isSideMenuMinified$ | async) === true ||
        ((isSideMenuMinified$ | async) === null && isDesktopScreen === false)
      "
    >
    </soft-side-menu>
  </div>
}

<div
  class="grid grid-rows-[fit-content(6rem)_1fr_fit-content(6rem)] screen-height w-full"
>
  <soft-title-bar
    class="soft-title-bar"
    [appearance]="shellAppearanceConfig()?.titleBar"
  ></soft-title-bar>
  <soft-pull-to-refresh-container
    softObserveElementSize
    (sizeChange)="contentSizeChanged($event)"
    cdkScrollable
    class="content shell-content flex flex-grow flex-col"
    [class.content-tablet]="isTabletScreen"
    (refresh)="refreshService.refresh()"
    [canRefresh]="refreshService.canRefresh()"
  >
    <!-- TODO: fix pull to refresh [canRefresh]="refreshService.canRefresh()" -->
    <router-outlet></router-outlet>
  </soft-pull-to-refresh-container>
  <soft-bottom-bar></soft-bottom-bar>
</div>

<div
  class="shell-message-bar-wrapper"
  [class.side-menu-opened]="
    (isTabletScreen || isDesktopScreen) &&
    (isSideMenuOpen$ | async) &&
    !(isSideMenuMinified$ | async) &&
    !((isActionMenuOpen$ | async) && (isActionMenuMinified$ | async) === false)
  "
  [class.action-menu-opened]="
    (isTabletScreen || isDesktopScreen) &&
    !((isSideMenuOpen$ | async) && !(isSideMenuMinified$ | async)) &&
    (isActionMenuOpen$ | async) &&
    (isActionMenuMinified$ | async) === false
  "
  [class.both-menues-opened]="
    (isTabletScreen || isDesktopScreen) &&
    (isSideMenuOpen$ | async) &&
    !(isSideMenuMinified$ | async) &&
    (isActionMenuOpen$ | async) &&
    (isActionMenuMinified$ | async) === false
  "
></div>

<soft-modal-container></soft-modal-container>

@if ((isActionMenuOpen$ | async) && (hasSideActions$ | async)) {
  <div
    class="sidebar right extended-actions action-menu"
    [class.z-502]="(isActionMenuMinified$ | async) === false"
    [class.shadow-right]="(isActionMenuMinified$ | async) === false"
    @slideInOut_Actions
  >
    <soft-side-actions
      (close)="
        isTabletScreen || isDesktopScreen ? minimizeActionMenu() : closeActionMenu()
      "
      (execute)="
        isTabletScreen
          ? minimizeActionMenu()
          : !isDesktopScreen
            ? closeActionMenu()
            : undefined
      "
      (open)="maximizeActionMenu()"
      [isMinified]="
        (isActionMenuMinified$ | async) === true ||
        (isActionMenuMinified$ | async) === null
      "
      [class.sidebar-minified]="
        (isActionMenuMinified$ | async) === true ||
        (isActionMenuMinified$ | async) === null
      "
    >
    </soft-side-actions>
  </div>
}

@if ((isSideMenuOpen$ | async) && (isSideMenuMinified$ | async) === false) {
  <div
    (click)="isTabletScreen ? minimizeSideMenu() : closeSideMenu()"
    class="overlay"
  ></div>
}
@if ((isActionMenuOpen$ | async) && (isActionMenuMinified$ | async) === false) {
  <div
    (click)="isTabletScreen ? minimizeActionMenu() : closeActionMenu()"
    class="overlay"
  ></div>
}
